// Local data structure for community posts with persistent state
import author1 from '../../../assets/images/community/author1.svg'
import author2 from '../../../assets/images/community/author2.svg'
import image1 from '../../../assets/images/community/john-marison.png'
import image2 from '../../../assets/images/community/sttaf.png'

let communityState = {
  posts: [
    {
      id: 1,
      author: "John Morrison, RN",
      authorImage: author1,
      time: "2 Hours ago",
      content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      image: image1,
      likes: 120,
      comments: 25,
      shares: 2,
      category: 'Salary',
      categoryTag: 'Salary discussion',
      liked: false,
      userReaction: null,
      reactions: {
        like: 85,
        love: 25,
        haha: 8,
        wow: 2,
        // sad: 1,
        angry: 1
      },
      reactionDetails: [
        { emoji: '👍', count: 85, users: ['John Doe', 'Sarah Wilson', 'Mike Johnson', 'Emma Davis'] },
        { emoji: '❤️', count: 25, users: ['Lisa Park', 'Tom Wilson', 'Alex Brown'] },
        { emoji: '😂', count: 8, users: ['James Rodriguez', 'Kelly Smith'] },
        { emoji: '😮', count: 2, users: ['David Lee'] }
      ],
      commentedUsers: ['You', 'Kathy Doe'],
      commentsList: [
        {
          id: 1,
          author: "John Morrison, RN",
          authorImage: author2,
          content: "Great insights! This really helps understand the current market trends.",
          image: image2,
          time: "2 hours ago",
          likes: 12,
          liked: false,
          userReaction: null,
          reactions: {
            like: 10,
            love: 2,
            haha: 0,
            wow: 0,
            sad: 0,
            angry: 0
          },
          replies: [
            {
              id: 11,
              author: "Sarah Wilson, RN",
              authorImage: "https://api.dicebear.com/7.x/avataaars/svg?seed=SarahWilson&backgroundColor=fecaca&clothingColor=374151",
              content: "Absolutely agree! The data is very comprehensive.",
              time: "1 hour ago",
              likes: 5,
              liked: false,
              parentId: 1
            },
            {
              id: 12,
              author: "Mike Johnson, RN",
              authorImage: "https://api.dicebear.com/7.x/avataaars/svg?seed=MikeJohnson&backgroundColor=bfdbfe&clothingColor=1f2937",
              content: "Thanks for sharing this valuable information!",
              time: "1 hour ago",
              likes: 3,
              liked: false,
              parentId: 1
            }
          ]
        },
        {
          id: 2,
          author: "Emma Davis, RN",
          authorImage: "https://api.dicebear.com/7.x/avataaars/svg?seed=EmmaDavis&backgroundColor=fed7aa&clothingColor=374151",
          content: "This is exactly what I was looking for. Thank you for the detailed breakdown!",
          time: "1 hour ago",
          likes: 8,
          liked: false,
          replies: []
        }
      ]
    },
    {
      id: 2,
      author: "Sarah Wilson, RN",
      authorImage: "https://api.dicebear.com/7.x/avataaars/svg?seed=SarahWilson&backgroundColor=fecaca&clothingColor=374151",
      time: "4 hours ago",
      content: "Just finished my shift at the ICU. It's been a challenging week with COVID cases rising again. How are you all managing the workload? Any tips for maintaining work-life balance during these tough times?",
      image: "https://picsum.photos/800/400?random=2",
      likes: 85,
      comments: 18,
      shares: 5,
      category: 'Speciality',
      categoryTag: 'ICU Discussion',
      liked: true,
      userReaction: 'love',
      reactions: {
        like: 45,
        love: 35,
        haha: 3,
        wow: 2,
        sad: 0,
        angry: 0
      },
      reactionDetails: [
        { emoji: '👍', count: 45, users: ['Mike Johnson', 'Lisa Park', 'James Rodriguez'] },
        { emoji: '❤️', count: 35, users: ['You', 'Emma Davis', 'Tom Wilson', 'Alex Brown'] },
        { emoji: '😂', count: 3, users: ['David Lee'] },
        { emoji: '😮', count: 2, users: ['Kelly Smith'] }
      ],
      commentedUsers: ['Emma Davis', 'Tom Wilson'],
      commentsList: [
        {
          id: 3,
          author: "Emma Davis, RN",
          authorImage: "https://api.dicebear.com/7.x/avataaars/svg?seed=EmmaDavis&backgroundColor=fed7aa&clothingColor=374151",
          content: "I totally understand! Self-care is so important. I've been doing meditation during breaks.",
          time: "3 hours ago",
          likes: 15,
          liked: false,
          replies: [
            {
              id: 31,
              author: "Sarah Wilson, RN",
              authorImage: "https://api.dicebear.com/7.x/avataaars/svg?seed=SarahWilson&backgroundColor=fecaca&clothingColor=374151",
              content: "That's a great idea! Do you have any meditation apps you'd recommend?",
              time: "2 hours ago",
              likes: 7,
              liked: false,
              parentId: 3
            }
          ]
        }
      ]
    },
    {
      id: 3,
      author: "Dr. Michael Chen",
      authorImage: "https://api.dicebear.com/7.x/avataaars/svg?seed=MikeJohnson&backgroundColor=bfdbfe&clothingColor=1f2937",
      time: "6 hours ago",
      content: "Excited to share that our hospital just implemented a new patient care protocol that has shown 30% improvement in recovery times. Collaboration between nursing and medical staff has been key to this success!",
      image: null,
      likes: 156,
      comments: 42,
      shares: 12,
      category: 'General',
      categoryTag: 'Healthcare Innovation',
      liked: false,
      userReaction: null,
      reactions: {
        like: 120,
        love: 25,
        haha: 8,
        wow: 3,
        sad: 0,
        angry: 0
      },
      reactionDetails: [
        { emoji: '👍', count: 120, users: ['Lisa Park', 'James Rodriguez', 'Sarah Wilson', 'Emma Davis'] },
        { emoji: '❤️', count: 25, users: ['Mike Johnson', 'Tom Wilson', 'Alex Brown'] },
        { emoji: '😂', count: 8, users: ['David Lee', 'Kelly Smith'] },
        { emoji: '😮', count: 3, users: ['John Doe'] }
      ],
      commentedUsers: ['Lisa Park', 'James Rodriguez', 'You'],
      commentsList: [
        {
          id: 4,
          author: "Lisa Park, RN",
          authorImage: "https://api.dicebear.com/7.x/avataaars/svg?seed=EmmaDavis&backgroundColor=fed7aa&clothingColor=374151",
          content: "This is amazing! Could you share more details about the protocol implementation?",
          time: "5 hours ago",
          likes: 22,
          liked: true,
          replies: [
            {
              id: 41,
              author: "Dr. Michael Chen",
              authorImage: "https://api.dicebear.com/7.x/avataaars/svg?seed=MikeJohnson&backgroundColor=bfdbfe&clothingColor=1f2937",
              content: "Of course! I'll be presenting this at next week's conference. The key was standardizing communication protocols.",
              time: "4 hours ago",
              likes: 15,
              liked: false,
              parentId: 4
            }
          ]
        }
      ]
    }
  ],
  nextCommentId: 100,
  nextReplyId: 200
};

// Helper functions for data manipulation
export const getCommunityData = () => {
  return { ...communityState };
};

export const getPostById = (postId) => {
  return communityState.posts.find(p => p.id === postId) || null;
};

export const updatePost = (postId, updates) => {
  const postIndex = communityState.posts.findIndex(post => post.id === postId);
  if (postIndex !== -1) {
    communityState.posts[postIndex] = { ...communityState.posts[postIndex], ...updates };
  }
  return communityState.posts[postIndex];
};

export const togglePostLike = (postId) => {
  const post = communityState.posts.find(post => post.id === postId);
  if (post) {
    post.liked = !post.liked;
    post.likes += post.liked ? 1 : -1;
  }
  return post;
};

export const setPostReaction = (postId, reactionType) => {
  const post = communityState.posts.find(post => post.id === postId);
  if (post) {
    const currentReaction = post.userReaction;
    const emojiMap = {
      like: '👍',
      love: '❤️',
      haha: '😂',
      wow: '😮',
      sad: '😢',
      angry: '😡'
    };
    
    // If clicking the same reaction, remove it
    if (currentReaction === reactionType) {
      post.reactions[reactionType] -= 1;
      post.userReaction = null;
      post.liked = false;
      
      // Update reaction details - remove user from this reaction
      const reactionDetail = post.reactionDetails.find(r => r.emoji === emojiMap[reactionType]);
      if (reactionDetail) {
        reactionDetail.count -= 1;
        reactionDetail.users = reactionDetail.users.filter(user => user !== 'You');
        if (reactionDetail.count === 0) {
          post.reactionDetails = post.reactionDetails.filter(r => r.emoji !== emojiMap[reactionType]);
        }
      }
    } else {
      // Remove previous reaction if exists
      if (currentReaction) {
        post.reactions[currentReaction] -= 1;
        const prevReactionDetail = post.reactionDetails.find(r => r.emoji === emojiMap[currentReaction]);
        if (prevReactionDetail) {
          prevReactionDetail.count -= 1;
          prevReactionDetail.users = prevReactionDetail.users.filter(user => user !== 'You');
          if (prevReactionDetail.count === 0) {
            post.reactionDetails = post.reactionDetails.filter(r => r.emoji !== emojiMap[currentReaction]);
          }
        }
      }
      
      // Add new reaction
      post.reactions[reactionType] += 1;
      post.userReaction = reactionType;
      post.liked = reactionType === 'like';
      
      // Update reaction details - add user to this reaction
      let reactionDetail = post.reactionDetails.find(r => r.emoji === emojiMap[reactionType]);
      if (reactionDetail) {
        reactionDetail.count += 1;
        if (!reactionDetail.users.includes('You')) {
          reactionDetail.users.unshift('You'); // Add 'You' at the beginning
        }
      } else {
        // Create new reaction detail
        post.reactionDetails.push({
          emoji: emojiMap[reactionType],
          count: 1,
          users: ['You']
        });
      }
    }
    
    // Update total likes count
    post.likes = Object.values(post.reactions).reduce((sum, count) => sum + count, 0);
    
    return post;
  }
  return null;
};

export const incrementShare = (postId) => {
  const post = communityState.posts.find(post => post.id === postId);
  if (post) {
    post.shares += 1;
  }
  return post;
};

export const addComment = (postId, commentData) => {
  const post = communityState.posts.find(post => post.id === postId);
  if (post) {
    const newComment = {
      id: communityState.nextCommentId++,
      ...commentData,
      time: "Just now",
      likes: 0,
      liked: false,
      replies: []
    };
    post.commentsList.push(newComment);
    post.comments += 1;
    return newComment;
  }
  return null;
};

export const addReply = (postId, commentId, replyData) => {
  const post = communityState.posts.find(post => post.id === postId);
  if (post) {
    const comment = post.commentsList.find(comment => comment.id === commentId);
    if (comment) {
      const newReply = {
        id: communityState.nextReplyId++,
        ...replyData,
        time: "Just now",
        likes: 0,
        liked: false,
        parentId: commentId
      };
      comment.replies.push(newReply);
      return newReply;
    }
  }
  return null;
};

export const toggleCommentLike = (postId, commentId) => {
  const post = communityState.posts.find(post => post.id === postId);
  if (post) {
    const comment = post.commentsList.find(comment => comment.id === commentId);
    if (comment) {
      comment.liked = !comment.liked;
      comment.likes += comment.liked ? 1 : -1;
      return comment;
    }
  }
  return null;
};

export const toggleReplyLike = (postId, commentId, replyId) => {
  const post = communityState.posts.find(post => post.id === postId);
  if (post) {
    const comment = post.commentsList.find(comment => comment.id === commentId);
    if (comment) {
      const reply = comment.replies.find(reply => reply.id === replyId);
      if (reply) {
        reply.liked = !reply.liked;
        reply.likes += reply.liked ? 1 : -1;
        return reply;
      }
    }
  }
  return null;
};

export const filterCategories = ['All posts', 'General', 'Salary', 'State', 'Speciality', 'Finance'];
